export default "__VITE_ASSET__C2JMrMEH__"